import ApolloErrorBoundary from '@components/ApolloErrorBoundary';
import { type FC, Suspense } from 'react';
import {
  type GateCommonData,
  useGateData,
  type UseGateCommonDataQueryOptions,
} from '../hooks/useGateCommonData';

interface Props {
  gateId: string;
  render: FC<GateCommonData>;
  fallback: FC;
  queryOptions?: UseGateCommonDataQueryOptions;
}

export const GateDataRenderer: FC<Props> = (props) => {
  const Fallback = props.fallback;

  return (
    <ApolloErrorBoundary variant="section-alert">
      <Suspense fallback={<Fallback />}>
        <SuspenseComponent {...props} />
      </Suspense>
    </ApolloErrorBoundary>
  );
};

const SuspenseComponent: FC<Props> = ({ gateId, render: Render, queryOptions }) => {
  const data = useGateData(gateId, queryOptions);
  return <Render {...data} />;
};
